import React from 'react';
import Articles from '../Components/Pages/Prototyping/Articles';
import Banner from '../Components/Pages/Prototyping/Banner';
import Container from '../Components/Pages/Prototyping/Container';
import Header from '../Components/Shared/Header/Header';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Prototyping(){
    return(
        <>
        <Header />
        <Banner />
        <Container />
        <Articles />
        <Jobs />
        <Start />
        <Footer />
        </>
    )
};
export default Prototyping ;